(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchItemSearch', PatchItemSearch);

    PatchItemSearch.$inject = ['$resource'];

    function PatchItemSearch($resource) {
        var resourceUrl =  'api/_search/patch-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
